import React, { useState } from "react";
import { Member360CustomerAnalytics } from "./member360/Member360CustomerAnalytics";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

export default function Member360() {
  const [searchInput, setSearchInput] = useState("");
  const [searchedMobileNo, setSearchedMobileNo] = useState<string | null>(null);
  const { toast } = useToast();

  const handleSearch = () => {
    const trimmed = searchInput.trim();
    if (!/^\d{10}$/.test(trimmed)) {
      toast({
        title: "Invalid mobile number",
        description: "Please enter a valid 10 digit mobile number.",
        variant: "destructive",
      });
      return;
    }
    setSearchedMobileNo(trimmed);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
    setSearchInput(value);
  };

  const handleReset = () => {
    setSearchInput("");
    setSearchedMobileNo(null);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Member 360 degree</h1>
        <p className="text-muted-foreground">
          Comprehensive member analytics and insights
        </p>
      </div>

      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-1 items-center gap-2 max-w-md">
          <Input
            placeholder="Enter 10 digit mobile number"
            className="flex-1"
            value={searchInput}
            onChange={handleInputChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            inputMode="numeric"
            maxLength={10}
          />
          <Button type="button" onClick={handleSearch}>
            Search
          </Button>
          <Button type="button" variant="outline" onClick={handleReset}>
            Reset
          </Button>
        </div>
      </div>

      {searchedMobileNo && (
        <div className="space-y-6">
          <Member360CustomerAnalytics mobileNo={searchedMobileNo} />
        </div>
      )}
    </div>
  );
}
